import React from 'react';
import { Car, CheckCircle2, Clock } from 'lucide-react';

const TONES = {
  amber: 'bg-amber-50 text-amber-800 border-amber-200 hover:bg-amber-100',
  blue: 'bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100',
  indigo: 'bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100',
  violet: 'bg-violet-50 text-violet-700 border-violet-200 hover:bg-violet-100',
  yellow: 'bg-yellow-50 text-yellow-800 border-yellow-200 hover:bg-yellow-100',
  green: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100',
  orange: 'bg-orange-50 text-orange-800 border-orange-200 hover:bg-orange-100',
  slate: 'bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100',
};

/** Row badge: the inspection stage a rep should act on, plus how long it has sat there. */
export const InspectionStageBadge = ({ badge, leadId, onClick }) => {
  if (!badge || !badge.total || !badge.stage) return null;

  const tone = TONES[badge.tone] || TONES.slate;
  const multi = badge.total > 1;
  const Icon = badge.stage === 'report_ready'
    ? CheckCircle2
    : badge.waiting_on === 'sales' ? Car : Clock;

  const label = badge.all_ready && multi
    ? `Report ready ${badge.ready}/${badge.total}`
    : badge.short_label;

  return (
    <button
      type="button"
      onClick={onClick}
      title={`${badge.label}${badge.age_label ? ` · ${badge.age_label} in this stage` : ''}${
        multi ? ` · ${badge.ready} of ${badge.total} reports ready` : ''
      } — click for the full inspection status`}
      data-testid={`inspection-stage-badge-${leadId}`}
      className={`mt-1.5 w-full inline-flex items-center gap-1 px-2 py-1 rounded-md border text-[11px] font-medium transition-colors ${tone}`}
    >
      <Icon className="h-3 w-3 flex-shrink-0" />
      <span className="truncate">{label}</span>
      {badge.age_label && badge.stage !== 'report_ready' && (
        <span className="opacity-70 flex-shrink-0">· {badge.age_label}</span>
      )}
      {multi && !badge.all_ready && (
        <span className="ml-auto opacity-70 flex-shrink-0">{badge.ready}/{badge.total}</span>
      )}
    </button>
  );
};

export default InspectionStageBadge;
